import { render, staticRenderFns } from "./InvoForm.vue?vue&type=template&id=129986ac&scoped=true"
import script from "./InvoForm.vue?vue&type=script&lang=js"
export * from "./InvoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129986ac",
  null
  
)

export default component.exports